// Angular
import { Injectable } from '@angular/core';

// Models
import { AppCleanup } from '../models';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
	providedIn: 'root',
})
export class CustomIconService extends AppCleanup {
	constructor(
		private matIconRegistry: MatIconRegistry,
		private domSanitizer: DomSanitizer
	) {
		super();
	}

	initilizeCustomIcons() {
		// this.matIconRegistry.addSvgIcon('ruler', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/custom-icons/ruler.svg'));

		this.matIconRegistry.addSvgIcon('in-progress', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/custom-icons/in-progress.svg'));

		this.matIconRegistry.addSvgIcon('company', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/custom-icons/company.svg'));

		// this.matIconRegistry.addSvgIcon('channel', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/custom-icons/channel.svg'));

		// this.matIconRegistry.addSvgIcon('more-circle', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/custom-icons/more-circle.svg'));

		// this.matIconRegistry.addSvgIcon('more-square', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/custom-icons/more-square.svg'));

		this.matIconRegistry.addSvgIcon('details', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/custom-icons/details.svg'));

		// this.matIconRegistry.addSvgIcon('layers', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/custom-icons/layers.svg'));

		// this.matIconRegistry.addSvgIcon('arrow-right-circle', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/custom-icons/arrow-right-circle.svg'));

		// this.matIconRegistry.addSvgIcon('arrow-left-circle', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/custom-icons/arrow-left-circle.svg'));

		this.matIconRegistry.addSvgIcon('double-arrow-right', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/custom-icons/double-arrow-right.svg'));

		// this.matIconRegistry.addSvgIcon('users', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/custom-icons/users.svg'));

		// this.matIconRegistry.addSvgIcon('upload', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/custom-icons/upload.svg'));

		// this.matIconRegistry.addSvgIcon('genderless', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/custom-icons/genderless.svg'));

		this.matIconRegistry.addSvgIcon('export', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/custom-icons/export.svg'));

		// this.matIconRegistry.addSvgIcon('pin', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/custom-icons/pin.svg'));

		// this.matIconRegistry.addSvgIcon('circle', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/custom-icons/circle.svg'));

		// this.matIconRegistry.addSvgIcon('download', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/custom-icons/download.svg'));

		// this.matIconRegistry.addSvgIcon('version', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/custom-icons/version.svg'));

		// this.matIconRegistry.addSvgIcon('oil-well', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/custom-icons/oil-well.svg'));

		// this.matIconRegistry.addSvgIcon('helmet', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/custom-icons/helmet.svg'));

		// this.matIconRegistry.addSvgIcon('truck', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/custom-icons/truck.svg'));
	}
}
